var render, staticRenderFns
import script from "./tableReferralProgramMixin.vue?vue&type=script&lang=js&"
export * from "./tableReferralProgramMixin.vue?vue&type=script&lang=js&"
import style0 from "./tableReferralProgramMixin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6569ef24",
  null
  
)

export default component.exports